module.exports = __webpack_public_path__ + "static/media/W18-1213_AW.CA_Mobile_767x845_EN.07884db0.jpg";